import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux'
import { Helmet } from "react-helmet";
import UnsubscribeBlock from "../util/UnsubscribeBlock";

import '../../scss/v2/user/unsubscribe.scss'

function Unsubscribe(props) {

    const { t, i18n } = useTranslation();

    useEffect(() => {
        i18n.changeLanguage(props.lang);
    }, [i18n, props.lang])

    return (
        <>
            <Helmet>
                <title>{t("meta.title.terminate")}</title>
                <meta name="description" content={t("meta.description.terminate")} />
            </Helmet>
            <div className="unsubscribe terminate container">
                <div className="row">
                    <div className="col-12 col-lg-8 offset-lg-2">
                        <UnsubscribeBlock />
                    </div>
                </div>
            </div>
        </>
    )

}

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(Unsubscribe);
